import type { PayoffDeliveryMethod } from '@ld.consumer-portal/models';
import type { PayoffDateConstraints, PayoffDateConstraintStrategy } from './date-constraint-strategy';
import { createDateFromToday } from './payoff-date.utils';

const MICHIGAN_MAX_DAYS = 6;

export class MichiganDateConstraintStrategy implements PayoffDateConstraintStrategy {
  getConstraints(deliveryMethod: PayoffDeliveryMethod): PayoffDateConstraints {
    if (deliveryMethod === 'Mail') {
      const fixedDate = createDateFromToday(MICHIGAN_MAX_DAYS);
      return {
        minDate: fixedDate,
        maxDate: fixedDate,
        isDatePickerDisabled: true,
      };
    }

    return {
      minDate: createDateFromToday(0),
      maxDate: createDateFromToday(MICHIGAN_MAX_DAYS),
      isDatePickerDisabled: false,
    };
  }
}
